(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-uniform"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('complete-uniform')) {
    customElements.define('complete-uniform', class extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        document.addEventListener('cart:update', this.refresh);
        if (this.dataset.pageType === 'product') document.addEventListener('variant:update', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() {
        document.removeEventListener('cart:update', this.refresh);
        document.removeEventListener('variant:update', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
        this.controller?.abort();
      }
      async refresh(event) {
        if (event.type === 'pageshow' && !event.persisted) return;
        if (event.detail?.data?.didError) return;
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const current = this.querySelector('[data-uniform-content]');
        if (current) current.hidden = true;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        if (event.type === 'variant:update' && event.detail?.resource?.id) url.searchParams.set('variant', event.detail.resource.id);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (controller.signal.aborted || !this.isConnected) return;
          const updated = html.querySelector('complete-uniform [data-uniform-content]');
          if (updated && current) current.replaceWith(updated);
        } catch (error) {
          if (error.name !== 'AbortError') this.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
